// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Rhw","footer":"styles_footer__2o78Y"};